import { useTranslation } from 'react-i18next';
import { useContext } from 'react';
import { WEBSITE_PATH } from '@karma/utils/constants/env';
import { Button, Stack, Typography } from '@karma/components';
import { WarningIcon } from '@karma/components/icons';
import { useSelector } from 'react-redux';
import Alooma from 'services/alooma';
import useAction from 'hooks/useAction';
import { pushBackKarmaEarnPlayMobileDevicesModal } from 'store/modals/actions';
import { PATHS } from 'consts/paths';
import * as ALOOMA from 'consts/alooma';
import { getUserId } from 'store/user/selectors';
import { Banner, ButtonsContainer, Image, Logo } from './ModalBodyKarmaEarnPlayAllDevices.style';

const ModalBodyKarmaEarnPlayAllDevices = ({ closeModal, item }) => {
  const { t } = useTranslation();
  const contextDataAttrs = Alooma.useContextDataAttrs();
  const userId = useSelector(getUserId);
  const pushBackKarmaEarnPlayMobileDevicesModalFunc = useAction(pushBackKarmaEarnPlayMobileDevicesModal);
  const aloomaSource = useContext(Alooma.SourceContext);

  const mobileClickHandler = () => {
    pushBackKarmaEarnPlayMobileDevicesModalFunc({ item });
    closeModal();
  };

  const desktopClickHandler = () => {
    window.open(
      `${WEBSITE_PATH}${PATHS.REDIRECT}?karma_earn_id=${item.id}&shop=${encodeURIComponent(
        item.title,
      )}&alooma_source=${aloomaSource}&user_id=${userId}`,
      '_blank',
    );
  };

  return (
    <>
      <Banner>
        <Image src={item.large_image} />
        <Logo src={item.logo} />
      </Banner>
      <Typography variant="paragraphMedium" align="center" bMargin={32}>
        {item.title}
      </Typography>
      <Typography variant="paragraphLarge" fontWeight={600} align="center" bMargin={12}>
        {t('app:chooseWhereYouPreferEarn')}
      </Typography>
      <ButtonsContainer>
        <Button
          size="medium"
          onClick={mobileClickHandler}
          {...contextDataAttrs}
          data-alooma-element={ALOOMA.ELEMENTS.MOBILE}
        >
          {t('app:mobile')}
        </Button>
        <Button
          size="medium"
          onClick={desktopClickHandler}
          {...contextDataAttrs}
          data-alooma-element={ALOOMA.ELEMENTS.DESKTOP}
        >
          {t('app:desktop')}
        </Button>
      </ButtonsContainer>
      <Stack spacing={4}>
        <WarningIcon size="small" color="color7" />
        <Typography variant="paragraphSmall" color="color7">
          {t('app:youCanNotEarnIf')}
        </Typography>
      </Stack>
    </>
  );
};

export default ModalBodyKarmaEarnPlayAllDevices;
